import React from 'react';
import theme from './Tooltip.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';

interface TooltipQuestionMarkProps {}

const TooltipQuestionMark: React.FC<TooltipQuestionMarkProps> = (props) => {
    return <FontAwesomeIcon className={theme.questionMark} icon={faQuestionCircle} />;
};

export default TooltipQuestionMark;
